var map = {
	"./1.png": "6f4a",
	"./2.png": "21fa",
	"./3.png": "7b5a",
	"./bottom.png": "d087",
	"./horizon-01.png": "a3aa",
	"./shadow-01.png": "c060",
	"./sun-illustration-01.png": "1d48",
	"./top.png": "ab03"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6e5";